import { render, staticRenderFns } from "./EditFiles.vue?vue&type=template&id=60d4b232&scoped=true"
import script from "./EditFiles.vue?vue&type=script&lang=js"
export * from "./EditFiles.vue?vue&type=script&lang=js"
import style0 from "./EditFiles.vue?vue&type=style&index=0&id=60d4b232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4b232",
  null
  
)

export default component.exports